import React, { useState } from "react";

function Dropdown({ options, defaultSelected, name, formlable, handleDropDownChange, status }) {
    const [selectedOption, setSelectedOption] = useState(defaultSelected);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isWrapperSelected, setIsWrapperSelected] = useState(false); // New state

    const toggleDropdown = () => {
        setIsDropdownOpen(prevState => !prevState);
    };

    const handleOptionSelect = option => {
        console.log("hello hello", name + " === " + option.value);
        handleDropDownChange(name, option);
        setSelectedOption(option);
        setIsWrapperSelected(true); // Add selected class to the wrapper
        toggleDropdown();
    };




    return (
        <div className={`form-box-color custom-select-container mt-3 ${isDropdownOpen ? 'open' : ''}`}>
            <div className="custom-form-group">
                <label className="dashboard-form-lable">{formlable}</label>
                <div className={`custom-select-wrapper w-60 ${isDropdownOpen ? 'open' : ''}`}>
                    <div className={`selected-option ${selectedOption?.value > 0 ? 'selected' : ''}`} onClick={status === true ? null : toggleDropdown}>

                        <div className="custom-option-label2">
                            {
                                selectedOption?.icon === '0' ? '' : <span className="option-icon">{selectedOption?.icon}</span>
                            }
                            <span className="option-text">{selectedOption?.label}</span>
                        </div>
                        {
                            status === true ? null : (
                                <i className={`bi ${isDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                            )
                        }
                    </div>
                    {isDropdownOpen && (
                        <div className="options-list">
                            {options.map(option => (
                                <div
                                    key={option.value}
                                    className={`option ${selectedOption?.value === option?.value ? 'selected' : ''}`}
                                    onClick={() => handleOptionSelect(option)}
                                >
                                    <div className="custom-option-label">
                                        <span className="option-icon">{option?.icon}</span>
                                        <span className="option-text">{option?.label}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Dropdown;
